export class PortalTimeoutChecker {
    constructor(msecs = 300000) {
        this.isTimedOut = false;
        this.msecs = msecs;
    }
    start() {
        this.timer = setInterval(this.check, this.msecs);
    }
    ;
    reset() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.start();
    }
    ;
    check() {
        const _this = this;
        const rawConn = new XMLHttpRequest();
        rawConn.open('POST', '/check-timeout');
        rawConn.send();
        rawConn.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.status == 401 && !_this.isTimedOut) {
                    _this.isTimedOut = true;
                    window.location.replace('/timeout');
                }
                else if (this.status == 200 && _this.isTimedOut) {
                    _this.isTimedOut = false;
                }
            }
        };
    }
}
